import classNames from 'classnames';
import { Routes } from 'react-router-dom';
import styles from './ListDetailView.module.css';
import { Loading } from './ui/Loading';
import { Resize } from './ui/resize/Resize';
import { Result } from './ui/Result';

type Props = {
  children: React.ReactNode;
  nav: React.ReactNode;
  actions: React.ReactNode;
  filters?: React.ReactNode;
  extra?: React.ReactNode;
  main: React.ReactNode;
  type?: string;
  background?: string;
  fetching?: boolean;
  count?: number;
  disableMainScrollContainer?: boolean;
  dynamicMarginTop?: string;
};

export const ListDetailView = ({
  children,
  actions,
  filters,
  extra,
  main,
  fetching,
  background,
  count,
  disableMainScrollContainer = false,
  dynamicMarginTop,
}: Props) => {
  return (
    <>
      {children && <Routes>{children}</Routes>}
      <div
        className={classNames(styles.parent, {
          [styles.parentNoSide as any]: !actions,
        })}
      >
        {actions && (
          <div className={classNames(styles.side)}>
            <Resize>
              <div className='flex h-full flex-col items-center justify-center overflow-y-auto'>
                <div className='flex flex-col'>{actions}</div>
              </div>
            </Resize>
          </div>
        )}
        <div className={classNames(styles.main)}>
          <div className='flex h-full flex-col border-r border-outline-variant bg-white'>
            <div className='block flex-none'>
              {filters}
              <div className='px-4'>{extra}</div>
            </div>
            <div
              className={classNames(
                background,
                'relative flex h-full flex-col bg-surface-container-background transition-all duration-200 ease-out',
                !disableMainScrollContainer && 'overflow-auto'
              )}
              data-split-main
              style={{
                marginTop: dynamicMarginTop,
              }}
            >
              {fetching ? (
                <div className='flex h-full items-center justify-center'>
                  <Loading spinner />
                </div>
              ) : (
                <>
                  {count !== undefined && (
                    <div className='px-4 pb-3 pt-4'>
                      <Result count={count} />
                    </div>
                  )}
                  {main}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
